<template>
  <div class="context-list auto-height auto-width">
    <button v-if="context.allowCopy" type="button" class="context-link" @click="copy">
      {{ $t('Copy') }}
    </button>
    <button v-if="context.allowPaste" type="button" class="context-link" @click="paste">
      {{ $t('Paste') }}
    </button>
    <button type="button" class="context-link context-link-red" @click="deleteTax">
      {{ $t('Delete') }}
    </button>
  </div>
</template>

<script>
  export default {
    name: 'ListTaxContext',
    props: {
      context: {
        type: Object,
        default: () => ({
          allowCopy: Boolean,
          allowPaste: Boolean,
          delete: Function,
          copy: Function,
          paste: Function,
        }),
      },
    },
    methods: {
      deleteTax() {
        this.context.delete?.();
        this.$emit('close');
      },
      copy() {
        this.context.copy?.();
        this.$emit('close');
      },
      paste() {
        this.context.paste?.();
        this.$emit('close');
      },
    },
  };
</script>
